import { Component, OnInit, Input, HostBinding, inject } from '@angular/core';
import { COMPONENT_VERSIONS, MixedLoyaltyItem } from '@fgb/core';

@Component({
  selector: 'fgbcl-mixed-loyalty-item',
  templateUrl: './mixed-loyalty-item.component.html',
  styleUrls: ['./mixed-loyalty-item.component.scss'],
})
export class MixedLoyaltyItemComponent implements OnInit {
  @Input() item: MixedLoyaltyItem;
  @Input() ignoreLink: boolean = false;
  @Input() featuredIcon: string = 'star';
  @HostBinding('class.disabled') get _isDisabled() {
    return this.ignoreLink;
  }

  version = inject(COMPONENT_VERSIONS);

  constructor() {}

  ngOnInit() {}
}
